import { getWindowProperty, setWindowProperty } from "./config";
var ScrollLock = /** @class */ (function () {
    function ScrollLock() {
    }
    Object.defineProperty(ScrollLock, "isEnabled", {
        get: function () {
            return getWindowProperty('__coreScrollLock__isEnabled', function () { return false; });
        },
        set: function (value) {
            setWindowProperty('__coreScrollLock__isEnabled', value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollLock, "scrollbarWidth", {
        get: function () {
            if (!document.getElementById(this.measuringElementId)) {
                var measurer = document.createElement('div');
                measurer.id = this.measuringElementId;
                document.body.appendChild(measurer);
                setWindowProperty('__coreScrollLock__scrollBarWidth', measurer.offsetWidth - measurer.clientWidth);
            }
            return getWindowProperty('__coreScrollLock__scrollBarWidth');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScrollLock, "scrollbarMargin", {
        get: function () {
            var _this = this;
            return getWindowProperty('__coreScrollLock__scrollBarMargin', function () { return "".concat(_this.scrollbarWidth, "px"); });
        },
        enumerable: false,
        configurable: true
    });
    ScrollLock.setEnabled = function (enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        this.isEnabled = enabled;
        var fullWidthFixedElements = Array.prototype.slice.call(document.getElementsByTagName('*'))
            .filter(function (o) { return getComputedStyle(o).position === 'fixed' && !o.hasAttribute('data-no-scroll-lock-offset'); });
        document.documentElement.classList[this.isEnabled ? 'add' : 'remove']('is-clipped');
        document.documentElement.style.marginRight = this.isEnabled ? this.scrollbarMargin : null;
        document.documentElement.style.backgroundColor = 'grey';
        document.body.style.backgroundColor = 'white';
        fullWidthFixedElements.forEach(function (o) { return o.style.marginRight = _this.isEnabled ? _this.scrollbarMargin : null; });
    };
    ScrollLock.measuringElementId = 'scrollbar-width-measure';
    return ScrollLock;
}());
export default ScrollLock;
